// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"lighthouse-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M6 21.9999C6 21.9999 8 14.9999 8 9.99985V3.00146H16V9.99985C16 14.9999 18 21.9999 18 21.9999H14L13 17.9999H11L10 21.9999H6Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8 2V3.00161M8 3.00161V10C8 15 6 22 6 22H10L11 18H13L14 22H18C18 22 16 15 16 10V3.00161M8 3.00161H16M16 3.00161V2M17 6H7M18 14H6","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 9.99805H12.0039V10.002H12V9.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-lighthouse-2')
export default class Lighthouse2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'lighthouse-2',
    }
  }
}
